import { render, staticRenderFns } from "./BaseRequiredField.vue?vue&type=template&id=35b999a2&"
import script from "./BaseRequiredField.vue?vue&type=script&lang=js&"
export * from "./BaseRequiredField.vue?vue&type=script&lang=js&"
import style0 from "./BaseRequiredField.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports